<template>
    <div class="n2-container">
        <div class="n2-nav-back">
            <a @click="$router.go(-1)" class="n2-link-back">
                <div style="display: flex; align-items:center;">
                    <i aria-hidden="true" class="fa fa-angle-left" style="font-size:2em;"></i>
                    <span style="margin-left:5px;">
                        {{ $t('pages.admin.role.back') }}
                    </span>
                </div>
            </a>
        </div>
        <div class="n2-page-title">
            <h3 v-if="id === 'new'">{{ $t('pages.admin.role.new') }}</h3>
            <h3 v-else>{{ $t('pages.admin.role.role') }}</h3>
        </div>
        <div class="n2-container">
            <form method="post" v-on:submit.prevent="onSubmit">
                <div class="n2-row-padding">
                    <div class="col-md-12">
                        <div class="n2-panel-default">
                            <form-input type="text" v-model="entity.name"
                                v-bind:label="$t('pages.admin.role.name')"
                                v-bind:errors="model_errors.name"></form-input>


                        </div>


                        <validation-summary v-bind:errors="model_errors"></validation-summary>

                        <div class="n2-form-group">
                            <div v-if="id === 'new'" class="n2-text-right">
                                <input type="submit" v-bind:value="$t('pages.admin.role.create')" class="n2-button-1" />
                            </div>
                            <div v-else class="n2-display-flex n2-justify-content-space-between">
                                <span class="n2-button-1 n2-button-delete"
                                    onclick="document.getElementById('n1-delete-modal').style.display='block'">{{ $t('pages.admin.role.delete') }}</span>
                                <input type="submit" v-bind:value="$t('pages.admin.role.save')" class="n2-button-1" />
                            </div>
                        </div>
                        <!--delete---------------------------------->
                        <div id="n1-delete-modal" class="w3-modal">
                            <div class="w3-modal-content w3-card-4" style="max-width:600px">
                                <div class="w3-center">
                                    <br>
                                    <span v-on:click="closeModal"
                                        class="w3-button w3-xlarge w3-hover-red w3-display-topright"
                                        title="Close Modal">&times;</span>
                                    <label class="n2-form-label">{{ $t('pages.admin.role.confirm_delete') }}</label>
                                </div>
                                <div class="w3-container w3-padding-16">
                                    <button type="button" class="n2-button-1 n2-button-delete n2-right"
                                        v-on:click="deleteEntity()">{{ $t('pages.admin.role.delete') }}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>


<script>
import { mapGetters } from 'vuex';
import {
    RoleService

} from '../services';
import FormInput from "../components/shared/form-input.vue";
import ValidationSummary from "../components/shared/validation-summary.vue";


export default {
    components: {
        FormInput, ValidationSummary
    },
    props: {
    },
    data: function () {
        return {
            model_errors: {},
            id: '',
            languages: [],
            entity: {
            },
        }
    },
    computed: {
        ...mapGetters('app_settings', [
            'company_id'
        ]),
        ...mapGetters('globalization', [
            'locale',
            'language'
        ]),

    },
    watch: {

    },
    created: function () {
        this.currentService = new RoleService();

    },
    mounted: async function () {
        const { id } = this.$route.params;
        this.id = id;
        if (id !== 'new') {
            await this.loadEntity(id);
        }
    },
    methods: {
        loadEntity: async function (id) {
            this.entity = await this.currentService.find(id);
        },



        closeModal: function () {
            var x = document.getElementsByClassName("w3-modal");
            var i;
            for (i = 0; i < x.length; i++) {
                x[i].style.display = "none";
            }
        },





        validateForm: function () {
            this.model_errors = {}
            if (!this.entity.name) {
                this.model_errors['name'] = [this.$t('pages.admin.role.error_name')]
            }


            //////////////////
            if (Object.keys(this.model_errors).length > 0) {
                return false
            }
            else {
                return true
            }
        },
        onSubmit: async function () {
            if (!this.validateForm()) {
                return false;
            }
            try {
                if (this.id === 'new') {
                    await this.currentService.create(this.entity);
                }
                else {
                    await this.currentService.update(this.entity.id, this.entity);
                }
                var parentPath = this.$route.path.substring(0,
                    this.$route.path.endsWith('/') ?
                        this.$route.path.substr(0, this.$route.path.length - 2).lastIndexOf('/')
                        : this.$route.path.lastIndexOf('/'));
                this.$router.push({
                    path: parentPath,
                    query: this.$route.query
                }).catch(() => {
                    //throw new Error(`Problem router push: ${err}.`);
                });
            }
            catch (err) {
                if (err.response) {
                    this.model_errors = err.response.data;
                }
            }
        },
        deleteEntity: async function () {
            try {
                await this.currentService.delete(this.id);
                var parentPath = this.$route.path.substring(0,
                    this.$route.path.endsWith('/') ?
                        this.$route.path.substr(0, this.$route.path.length - 2).lastIndexOf('/')
                        : this.$route.path.lastIndexOf('/'));
                this.$router.push({
                    path: parentPath,
                    query: this.$route.query
                }).catch(() => {
                    //throw new Error(`Problem router push: ${err}.`);
                });
            }
            catch (err) {
                if (err.response) {
                    this.model_errors = err.response.data;
                }
            }
        },
    },

}
</script>